import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeaturesModule } from '@cigna/features';
import { OmniChatModule } from '@cigna/omni/chat';
import { OmniChatBubbleModule } from '@cigna/omni/chat-bubble';
import { OmniInterceptionsModule } from '@cigna/omni/interceptions';
import { OmnibusInitializationModule } from '@cigna/omni/omnibus-initialization';
import { OmniPollingStateModule } from '@cigna/omni/polling-state';
import { OmniRightNowDataAccessModule } from '@cigna/omni/right-now-data-access';
import { OmniEntryComponent } from './omni-entry/omni-entry.component';
import { OmniNoBubbleEntryComponent } from './omni-no-bubble-entry/omni-no-bubble-entry.component';
import { OmniFancyInvitationsModule } from '@cigna/omni/fancy-invitations';

@NgModule({
  imports: [
    CommonModule,
    OmnibusInitializationModule,
    OmniChatBubbleModule,
    OmniChatModule,
    OmniFancyInvitationsModule,
    OmniInterceptionsModule,
    OmniPollingStateModule,
    OmniRightNowDataAccessModule,
    FeaturesModule,
  ],
  declarations: [OmniEntryComponent, OmniNoBubbleEntryComponent],
  exports: [OmniEntryComponent, OmniNoBubbleEntryComponent],
})
export class OmniEntryModule {}
